import Marquee from "react-fast-marquee";

const WORDS = [
  "Nosferatu",
  "Metropolis",
  "Caligari",
  "Night of the Living Dead",
  "A Trip to the Moon",
  "Carnival of Souls",
  "White Zombie",
  "Plan 9 from Outer Space",
];

export const Ribbon = () => {
  return (
    <div
      data-testid="editorial-marquee"
      className="border-y border-white/10 bg-black py-5 md:py-6 relative z-20"
    >
      <Marquee speed={38} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-2xl md:text-4xl text-bone px-6 md:px-10">
              {w}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-blood" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
